import { render } from "./MatchTypeFilterItem.vue?vue&type=template&id=065ea4b8"
import script from "./MatchTypeFilterItem.vue?vue&type=script&lang=js"
export * from "./MatchTypeFilterItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__